import React from 'react';

import Chart from 'components/Chart';
import { useModal } from 'components/Modal';
import { useScreenDispatch, useScreenState } from 'components/Screen';
import { SelectPicker } from 'components/Select';
import { useChart } from 'scenes/DashboardPage/data';
import { useMetrics } from 'scenes/DashboardPage/data/useMetrics';
import { SET_METRICS } from 'scenes/DashboardPage/screenReducer';

const DashboardChart = () => {
  const screenState = useScreenState();
  const dispatch = useScreenDispatch();

  const {
    data: chartData,
    isRefetching,
    isLoading,
    isError,
    error,
    isSuccess,
  }: any = useChart({
    metrics: screenState.metrics,
    filters: screenState.filters,
  });

  const { data: metricsData } = useMetrics();

  const [showMetricsModal] = useModal(SelectPicker, {
    value: screenState.metrics,
    data: metricsData,
  });
  const handleOpenMetricsModal = () => {
    showMetricsModal({
      title: 'Metrics',
      multiple: true,
      onSubmit: (value: number[]) => {
        dispatch({
          type: SET_METRICS,
          payload: value,
        });
      },
    });
  };

  return (
    <Chart
      showMetricsModal={handleOpenMetricsModal}
      isRefetching={isRefetching}
      isLoading={isLoading}
      isError={isError}
      isSuccess={isSuccess}
      error={error}
      data={chartData}
    />
  );
};

export default DashboardChart;
